import { UNIT_MIGRATION_EVENT_TYPES } from './pal-unit.type';

export const PAL_ADMIN_UNIT_ID_MIN = 1_000_000;

export function isPalAdminUnitId(adminUnitId: number): boolean {
    return Number.isFinite(adminUnitId) && adminUnitId >= PAL_ADMIN_UNIT_ID_MIN;
}

export type PropertyManagerConfigUploadRequest = {
    file: string;
    file_name?: string;
};

export type PropertyManagerConfigEventType =
    | typeof UNIT_MIGRATION_EVENT_TYPES.PAL_UNIT_PM_CONFIG
    | typeof UNIT_MIGRATION_EVENT_TYPES.PAL_UNIT_OVERRIDE_CONFIG;

export type PropertyManagerConfigRowData = {
    pms_id?: string;
    admin_unit_id?: number | string;
    unit_id?: number | string;
    config: Record<string, unknown>;
};

export type ParseAndQueueSummary = {
    queued: number;
    pm_config: number;
    unit_config_override: number;
    skipped: number;
    skipped_details?: Record<string, number>;
};

export type UnitMigrationRollbackQueueSummary = {
    queued: number;
    skipped_invalid: number;
    duplicates_removed: number;
    skipped_below_min_admin_unit_id: number;
};

export type ParsedConfigRow = {
    sheetName: string;
    rowNumber: number;
    eventType: PropertyManagerConfigEventType;
    row: Record<string, unknown>;
};

export type PmFallbackData = {
    pms_id?: string;
    config: Record<string, unknown>;
};

/** SQS / orchestrstrator envelope for PM config and unit override events */
export type PropertyManagerConfigPayload = {
    type: PropertyManagerConfigEventType;
    data?: PropertyManagerConfigRowData;
    metadata?: {
        source?: string;
        file_name?: string;
        sheet_name?: string;
        row_number?: number;
    };
};

export const PM_CONFIG_ID_COLUMNS = ['pms_id', 'pm_id'];
export const UNIT_CONFIG_ID_COLUMNS = ['vacasa_admin_unit_id', 'admin_unit_id', 'unit_id'];

// Exact column names from the provided CSV tabs, normalized with snake_case.
export const PM_CONFIG_ALLOWED_COLUMNS = [
    'show_pre_transition_vacasa_reviews_on_vacasa',
    'show_pre_transition_vacasa_reviews_on_casago',
    'show_streamline_reviews_on_vacasa',
    'show_guesty_reviews_on_vacasa',
];

export const UNIT_CONFIG_ALLOWED_COLUMNS = ['show_pre_transition_vacasa_reviews_on_vacasa', 'show_pre_transition_vacasa_reviews_on_casago'];

export const BOOLEAN_CONFIG_COLUMNS = [...PM_CONFIG_ALLOWED_COLUMNS, ...UNIT_CONFIG_ALLOWED_COLUMNS];

export const COLUMN_KEY_ALIASES: Record<string, string> = {
    // PM config aliases with domain suffixes from spreadsheet/csv headers.
    show_pre_transition_vacasa_com_reviews_on_vacasa_com: 'show_pre_transition_vacasa_reviews_on_vacasa',
    show_pre_transition_vacasa_com_reviews_on_casago_com: 'show_pre_transition_vacasa_reviews_on_casago',
    show_pre_transition_vacasa_com_reviews_on_vacasa: 'show_pre_transition_vacasa_reviews_on_vacasa',
    show_pre_transition_vacasa_com_reviews_on_casago: 'show_pre_transition_vacasa_reviews_on_casago',
    show_streamline_reviews_on_vacasa_com: 'show_streamline_reviews_on_vacasa',
    show_guesty_reviews_on_vacasa_com: 'show_guesty_reviews_on_vacasa',

    // Unit override aliases with domain suffixes.
    show_pre_transition_vacasa_reviews_on_vacasa_com: 'show_pre_transition_vacasa_reviews_on_vacasa',
    show_pre_transition_vacasa_reviews_on_casago_com: 'show_pre_transition_vacasa_reviews_on_casago',
    show_pre_transition_vacasa_reviews_on_vacasa: 'show_pre_transition_vacasa_reviews_on_vacasa',
    show_pre_transition_vacasa_reviews_on_casago: 'show_pre_transition_vacasa_reviews_on_casago',
    show_streamline_reviews_on_vacasa_com_: 'show_streamline_reviews_on_vacasa',
    show_guesty_reviews_on_vacasa_com_: 'show_guesty_reviews_on_vacasa',
};
